/* eslint-disable react/prop-types */
import React from 'react';
import { useTranslation } from 'react-i18next';
// components
import SmallLoading from '../../element/SmallLoading';

const CheckEmailCodeForm = ({
  setStep,
  onSubmit,
  isSubmitting,
  emailConfirmCode,
  setEmailConfirmCode,
  emailConfirmCodeError,
  setEmailConfirmCodeError,
}) => {
  const { t } = useTranslation('global');

  return(
    <form onSubmit={onSubmit}>
      <div className='mb-4'>
        <label className='mb-2 fw-bold' htmlFor='code'>
          {t('jobDescription.code')}
          <span className='RedStar'>*</span>
        </label>
        <input
          id='code'
          name='code'
          type='text'
          value={emailConfirmCode}
          placeholder={t('jobDescription.codePlaceholder')}
          className={`form-control ${emailConfirmCodeError && 'input-error'}`}
          onChange={e => {
            setEmailConfirmCode(e.target.value);
            setEmailConfirmCodeError('');
          }}
        />
        {
          emailConfirmCodeError && (
            <div className='text-danger'>{emailConfirmCodeError}</div>
          )
        }
      </div>
      <div className='d-flex justify-content-evenly'>
        <button
          type='button'
          className='btn button2'
          onClick={() => setStep('checkUser')}
        >
          {t('jobDescription.backButton')}
        </button>
        <button
          type='submit'
          onClick={onSubmit}
          disabled={isSubmitting}
          className='mt-0 btn button1'
        >
          {t('jobDescription.continueButton')}{' '}
          {isSubmitting && <SmallLoading width='24px' height='24px' color='#FFF' style={{ marginLeft: '8px' }} />}
        </button>
      </div>
    </form>
  );
};

export default CheckEmailCodeForm;
